import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import AdminWorkspaceChildList from "@/components/admin/admin-workspace-child-list";

const AdminWorkspaceProjectsPage = (): JSX.Element => {
	const { workspaceId } = Route.useParams();
	return <AdminWorkspaceChildList entity="projects" workspaceId={workspaceId} />;
};

export const Route = createFileRoute("/_app/admin/workspaces/$workspaceId/projects")({
	component: AdminWorkspaceProjectsPage,
});
